import Head from './myComponents/Head.js';
import Home from './myComponents/Home.js';
// import Gallery from './myComponents/Gallery.js';
import Aboutme from './myComponents/Aboutme.js';
import Education from './myComponents/Education.js';
import Project from './myComponents/Project.js';
import Experience from './myComponents/Experience.js';
import Contact from './myComponents/Contact.js';
import Hobby from './myComponents/Hobby.js';
import Footer from './myComponents/Footer.js';
import Resume from './myComponents/resume.js';
import './app.css'

function App() {
  return (
    <>
       <Head />
      <section id="home"><Home /></section>
      <div className="phrase5">"Stay as calm as the sea & as mysterious as its depth"</div>
      <section id="education"><Education /></section>
      <div className="phrase1">"Never compromise on Quality, Loyalty & Integrity"</div>
      <section id="project"><Project /></section>
      <section id="resume"><Resume /></section>
      <section id="experience"><Experience /></section>
      <div className="phrase2">"My journey is to the Island of Relevancy"</div>
      <section id="about"><Aboutme /></section>
      <div className="phrase3">"Keep Upgrading yourself. No one is coming to Save you"</div>
      <Hobby />
      {/* <section id="gallery"><Gallery /></section> */}
      <div className="phrase4">"Don't be my supporter. Be a doubter. It's way more fun destroying doubts."</div>
      <section id="contact"><Contact /></section>
      <Footer />
    </>
  );
}

export default App;
